import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import Header from './components/header';
import {
  BrowserRouter,
  useLocation,
} from "react-router-dom";
import {
  AuthProvider,
  useAuth,
} from "./components/AuthContext";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';

const AppLayout = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  const isLoginPage =
    location.pathname === "/login";

  const showHeader =
    isAuthenticated && !isLoginPage;

  return (
    <div className="min-h-screen">
      <div className="grid grid-cols-12">
        {showHeader && (
          <div className="col-span-12">
            <Header />
          </div>
        )}

        <main className="col-span-12 flex">
          <div className="w-full">
            <App />
          </div>
        </main>
      </div>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <PersistGate
      loading={null}
      persistor={persistor}
    >
      <AuthProvider>
        <BrowserRouter>
          <AppLayout />
        </BrowserRouter>
      </AuthProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


